import { StatusAcceptanceEnum } from '@features/ConsolidatorTracking/model/consolidator';
import { Weight } from '@shared/types/parcel';
import { DataRow } from '@uni-space/uni-components';

// Коробку по объёму рекомендуем только экспресс-посылкам: до 20 л — BOX-L,
// 20–50 л — мешок 120x80, свыше 50 л — мешок 120x180. Все остальные посылки едут в мешке.
export enum RecommendedBoxEnum {
  BoxUnspecified = 0,
  BoxL = 1,
  Box80 = 2,
  Box180 = 3,
  Bag = 4,
}

export type BigsSuccessRow = DataRow<{
  trackNumber: string;
  regionZone: string;
  bagCode: string;
  sortingCode: string;
  weight: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  density: number | null;
  recommendedBox: RecommendedBoxEnum | null;
  needGroundTransport: boolean;
  scanAt: Date;
  id: string;
}>;

export type BigsErrorRow = DataRow<{
  trackNumber: string;
  status: StatusAcceptanceEnum;
  id: string;
}>;

export interface AcceptanceBigHardwareHubResponse {
  userId: string;
  bagCode: string | null;
  trackNumber: string | null;
  weight: Weight | null;
  length: number | null;
  width: number | null;
  height: number | null;
  density: number | null;
  scanAt: string | null;
  regionZone: string | null;
  status: StatusAcceptanceEnum;
  sortingCode: string | null;
  // при BoxUnspecified бэк присылает null, а не 0
  recommendedBox: RecommendedBoxEnum | null;
}
